import React, { useState, useEffect } from 'react';
import api from '../../utils/api';

export default function AdminReports() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchReports = async () => {
    setLoading(true);
    try {
      const res = await api.get('/admin/reports/');
      setReports(res.data.reports || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchReports(); }, []);

  const updateStatus = async (id, status) => {
    try {
      await api.put(`/admin/reports/${id}/`, { status });
      setReports(prev => prev.map(r => r.id === id ? { ...r, status } : r));
    } catch (err) { alert('Failed to update status'); }
  };

  const deleteReport = async (id) => {
    if (!window.confirm('Delete this report?')) return;
    try {
      await api.delete(`/admin/reports/${id}/`);
      setReports(prev => prev.filter(r => r.id !== id));
    } catch (err) { alert('Failed to delete report'); }
  };

  return (
    <div style={{ padding: 24, flex: 1, overflowY: 'auto', background: '#07070d' }}>
      <h2 style={{ color: '#e2e8f0', marginTop: 0, marginBottom: 20 }}>Reports</h2>
      
      {loading ? (
        <div style={{ color: '#64748b' }}>Loading...</div>
      ) : reports.length === 0 ? (
        <div style={{ color: '#64748b' }}>No reports found.</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {reports.map(r => (
            <div key={r.id} style={{ background: '#111118', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 12, padding: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                <div style={{ color: '#94a3b8', fontSize: 12 }}>
                  Reported by <strong style={{ color: '#818cf8' }}>{r.reporter_username}</strong> on {new Date(r.created_at).toLocaleDateString()}
                </div>
                <select 
                  value={r.status} 
                  onChange={e => updateStatus(r.id, e.target.value)}
                  style={{ background: '#1a1a2e', color: r.status === 'resolved' ? '#4ade80' : r.status === 'dismissed' ? '#94a3b8' : '#fbbf24', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 6, padding: '4px 8px', fontSize: 11, outline: 'none' }}
                >
                  <option value="pending">Pending</option>
                  <option value="reviewed">Reviewed</option>
                  <option value="resolved">Resolved</option>
                  <option value="dismissed">Dismissed</option>
                </select>
              </div>
              <div style={{ fontSize: 13, color: '#e2e8f0', marginBottom: 12 }}>
                {r.reported_user_username && <div><strong>User:</strong> {r.reported_user_username}</div>}
                {r.reported_post_id && <div><strong>Post ID:</strong> {r.reported_post_id}</div>}
                <div style={{ marginTop: 4 }}><strong>Reason:</strong> {r.reason}</div>
              </div>
              <button style={{ background: 'rgba(239,68,68,0.1)', color: '#ef4444', border: '1px solid rgba(239,68,68,0.2)', padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 12 }} onClick={() => deleteReport(r.id)}>
                Delete Report
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
